module.exports = __webpack_public_path__ + "static/media/telegram_icon.06c878b4.png";